// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom"; 
// import AdminAppBody from "../../../../components/admin/AdminAppBody";
// import useApiCallHooks from "../../../../hooks/useApiCallHooks";
// import Select from "react-select";
// import { toast } from "react-toastify";

// const MentorAssignNewTask = () => {
//     const navigate = useNavigate(); 

//     const [programs, setPrograms] = useState([]);
//     const [students, setStudents] = useState([]);
//     const [modules, setModules] = useState([]);
//     const [topics, setTopics] = useState([]);
//     const [groups, setGroups] = useState([]);
//     const [tasks, setTasks] = useState([]);
//     const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

//     const [form, setForm] = useState({
//         program_id: "",
//         user_type: "",
//         module_id: "",
//         topic_id: "",
//         due_date: "",
//         type: "individual",
//         student_ids: [],
//         group_ids: [], 
//         task_ids: [],
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prev) => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     const handleSubmit = () => {
//         const sessionData = { ...form };
//         console.log("Submitted Data:", sessionData);
        
//         callAPI("post", "mentor/assign-task", sessionData);
//     };

//     // Get students list
//     useEffect(() => {
//         if (form.user_type) {
//             callAPI("get", `get-program-student-list/${form.user_type}`, "");
//         }
//     }, [form.user_type]);

//     // Get modules when program changes
//     useEffect(() => {
//         if (form.program_id) {
//             callAPI("get", `road-map/${form.program_id}`, "");
//         }
//     }, [form.program_id]);

//     // Get topics when module changes
//     useEffect(() => {
//         if (form.module_id) {
//             callAPI("get", `module-wise-topic/${form.module_id}`, "");
//         }
//     }, [form.module_id]);
//     //task
//     useEffect(() => {
//         if (form.topic_id) {
//             callAPI("get", `mentor/get-task-list/${form.topic_id}`, "");
//         }
//     }, [form.topic_id]);
//     // Load groups on mount
//     useEffect(() => {
//         callAPI("get", `mentor/mentor-group-student-list`, "");
//     }, []);

//     // Handle API responses
//     useEffect(() => {
//         if (!responce?.data) return;

//         const data = responce.data;

//         console.log("API Message:", responce.message);
//         console.log("API Data:", data);

//         if (Array.isArray(data.programs)) setPrograms(data.programs);
//         if (Array.isArray(data.students)) setStudents(data.students);
//         if (responce.message === "RoadMapModules" && Array.isArray(data))
//             setModules(data);
//         if (
//             Array.isArray(data) &&
//             data[0]?.module_id &&
//             responce.message === "RoadMapTopics"
//         )
//             setTopics(data);
//         if (data.groups && Array.isArray(data.groups)) setGroups(data.groups);
//         if (responce.message === "MentorTask" && Array.isArray(data)) {
//             setTasks(data);
//         }

//         // ✅ Navigate to session list after successful session creation
//        if (statusCode === 201) {
//     toast.success("Task assigned successfully!");
//     setTimeout(() => {
//       navigate("/mentor-assigntask");
//     }, 2000); // 1 second delay so user sees the toast
//   }
//     }, [responce]);
//     console.log(tasks)

//     return (
//         <AdminAppBody
//             loading={loading}
//             content={
//                 <div className="container mt-3">
//                     <h3>Assign Task</h3>
//                     <div className="card shadow">
//                         <div className="card-body">
//                             {/* Program & User Type */}
//                             <div className="row mb-3">
//                                 <div className="col-md-6">
//                                     <label>Student Type</label>
//                                     <select
//                                         className="form-control"
//                                         name="user_type"
//                                         value={form.user_type}
//                                         onChange={handleChange}
//                                         required
//                                     >
//                                         <option value="">
//                                             -- Select Student Type --
//                                         </option>
//                                         <option value="kids">Kids</option>
//                                         <option value="student">Student</option>
//                                     </select>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <label>Select Program</label>
//                                     <select
//                                         className="form-select"
//                                         name="program_id"
//                                         value={form.program_id}
//                                         onChange={handleChange}
//                                     >
//                                         <option value="">Select</option>
//                                         {programs.map((prog) => (
//                                             <option
//                                                 key={prog.id}
//                                                 value={prog.id}
//                                             >
//                                                 {prog.name}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Module & Topic */}
//                             <div className="row mb-3">
//                                 <div className="col-md-6">
//                                     <label>Select Module</label>
//                                     <select
//                                         className="form-select"
//                                         name="module_id"
//                                         value={form.module_id}
//                                         onChange={handleChange}
//                                         disabled={!modules.length}
//                                     >
//                                         <option value="">Select Module </option>
//                                         {modules.map((mod) => (
//                                             <option key={mod.id} value={mod.id}>
//                                                 {mod.name}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div className="col-md-6">
//                                     <label>Select Topic</label>
//                                     <select
//                                         className="form-select"
//                                         name="topic_id"
//                                         value={form.topic_id}
//                                         onChange={handleChange}
//                                         disabled={!topics.length}
//                                     >
//                                         <option value="">
//                                             -- Select Topic --
//                                         </option>
//                                         {topics.map((topic) => (
//                                             <option
//                                                 key={topic.id}
//                                                 value={topic.id}
//                                             >
//                                                 {topic.name}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Date & Time */}
//                             <div className="row mb-3">
//                                 <div className="col-md-6">
//                                     <label>Due Date</label>
//                                     <input
//                                         type="date"
//                                         name="due_date"
//                                         className="form-control"
//                                         value={form.due_date}
//                                         onChange={handleChange}
//                                     />
//                                 </div>

//                                 <div className="col-md-6">
//                                     <label>Available Tasks</label>
//                                     <Select
//                                         isMulti
//                                         name="task_ids"
//                                         options={tasks.map((task) => ({
//                                             value: task.id,
//                                             label:
//                                                 task.task || `Task ${task.id}`,
//                                         }))}
//                                         value={tasks
//                                             .filter((t) =>
//                                                 form.task_ids.includes(t.id)
//                                             )
//                                             .map((t) => ({
//                                                 value: t.id,
//                                                 label:
//                                                    t.task,
//                                             }))}
//                                         onChange={(selectedOptions) =>
//                                             setForm((prev) => ({
//                                                 ...prev,
//                                                 task_ids: selectedOptions.map(
//                                                     (option) => option.value
//                                                 ),
//                                             }))
//                                         }
//                                     />
//                                 </div>
//                             </div>

//                             {/* Session Type */}
//                             <div className="mb-3">
//                                 <label>Session Type:</label>
//                                 {["individual", "group"].map((type) => (
//                                     <div
//                                         className="form-check form-check-inline ms-2"
//                                         key={type}
//                                     >
//                                         <input
//                                             type="radio"
//                                             className="form-check-input"
//                                             name="type"
//                                             value={type}
//                                             checked={form.type === type}
//                                             onChange={(e) => {
//                                                 setForm((prev) => ({
//                                                     ...prev,
//                                                     type: e.target.value,
//                                                     student_ids: [],
//                                                     group_id: "",
//                                                 }));
//                                             }}
//                                         />
//                                         <label className="form-check-label text-capitalize">
//                                             {type}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>

//                             {/* Conditional: Students or Group */}
//                             {form.type === "individual" && (
//                                 <div className="mb-3">
//                                     <label>Select Students</label>
//                                     <Select
//                                         isMulti
//                                         name="student_ids"
//                                         options={students.map((student) => ({
//                                             value: student.id,
//                                             label: student.first_name,
//                                         }))}
//                                         value={students
//                                             .filter((s) =>
//                                                 form.student_ids.includes(s.id)
//                                             )
//                                             .map((s) => ({
//                                                 value: s.id,
//                                                 label: s.first_name,
//                                             }))}
//                                         onChange={(selectedOptions) =>
//                                             setForm((prev) => ({
//                                                 ...prev,
//                                                 student_ids:
//                                                     selectedOptions.map(
//                                                         (option) => option.value
//                                                     ),
//                                             }))
//                                         }
//                                     />
//                                 </div>
//                             )}

//                             {form.type === "group" && (
//                                 <div className="mb-3">
//                                     <label>Select Group</label>
//                                     <Select
//                                         name="group_ids"
//                                         options={groups.map((group) => ({
//                                             value: group.id,
//                                             label: group.name,
//                                         }))}
//                                       value={
//   groups
//     .filter((g) => form.group_ids.includes(g.id))
//     .map((g) => ({
//       value: g.id,
//       label: g.name,
//     }))[0] || null
// }

//                                       onChange={(selectedOption) =>
//   setForm((prev) => ({
//     ...prev,
//     group_ids: selectedOption ? [selectedOption.value] : [],
//   }))
// }
//                                     />
//                                 </div>
//                             )}

//                             {/* Submit */}
//                             <div className="text-end">
//                                 <button
//                                     className="btn btn-primary"
//                                     onClick={handleSubmit}
//                                 >
//                                     Submit
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             }
//         />
//     );
// };

// export default MentorAssignNewTask;


// Ensure this remains at the top
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; 
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import Select from "react-select";
import { toast } from "react-toastify";

const MentorAssignNewTask = () => {
  const navigate = useNavigate(); 
  const [programs, setPrograms] = useState([]);
  const [students, setStudents] = useState([]);
  const [modules, setModules] = useState([]);
  const [topics, setTopics] = useState([]);
  const [groups, setGroups] = useState([]);
  const [tasks, setTasks] = useState([]);

  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

  const [form, setForm] = useState({
    program_id: "",
    user_type: "",
    module_id: "",
    topic_id: "",
    due_date: "",
    type: "individual",
    student_ids: [],
    group_ids: [], 
    task_ids: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const sessionData = { ...form };

    // Ensure arrays are sent properly
    sessionData.student_ids = Array.isArray(sessionData.student_ids) ? sessionData.student_ids : [];
    sessionData.group_ids = Array.isArray(sessionData.group_ids) ? sessionData.group_ids : [];
    sessionData.task_ids = Array.isArray(sessionData.task_ids) ? sessionData.task_ids : [];

    callAPI("post", "mentor/assign-task", sessionData);
  };

  useEffect(() => {
    if (form.user_type) {
      callAPI("get", `get-program-student-list/${form.user_type}`, "");
    }
  }, [form.user_type]);

  useEffect(() => {
    if (form.program_id) {
      callAPI("get", `road-map/${form.program_id}`, "");
    }
  }, [form.program_id]);

  useEffect(() => {
    if (form.module_id) {
      callAPI("get", `module-wise-topic/${form.module_id}`, "");
    }
  }, [form.module_id]);

  useEffect(() => {
    if (form.topic_id) {
      callAPI("get", `mentor/get-task-list/${form.topic_id}`, "");
    }
  }, [form.topic_id]);

  useEffect(() => {
    callAPI("get", `mentor/mentor-group-student-list`, "");
  }, []);

  useEffect(() => {
    if (!responce?.data) return;

    const data = responce.data;

    if (Array.isArray(data.programs)) setPrograms(data.programs);
    if (Array.isArray(data.students)) setStudents(data.students);
    if (responce.message === "RoadMapModules" && Array.isArray(data)) setModules(data);
    if (responce.message === "RoadMapTopics" && Array.isArray(data)) setTopics(data);
    if (data.groups && Array.isArray(data.groups)) setGroups(data.groups);
    if (responce.message === "MentorTask" && Array.isArray(data)) setTasks(data);

    if (statusCode === 201) {
      toast.success("Task assigned successfully!");
      setTimeout(() => navigate("/mentor-assigntask"), 2000);
    }
  }, [responce]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-3">
          <h3>Assign Task</h3>
          <div className="card shadow">
            <div className="card-body">

              {/* Select Student Type & Program */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label>Student Type</label>
                  <select className="form-control" name="user_type" value={form.user_type} onChange={handleChange}>
                    <option value="">-- Select Student Type --</option>
                    <option value="kids">Kids</option>
                    <option value="student">Student</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label>Select Program</label>
                  <select className="form-select" name="program_id" value={form.program_id} onChange={handleChange}>
                    <option value="">Select</option>
                    {programs.map((prog) => (
                      <option key={prog.id} value={prog.id}>{prog.name}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Module and Topic */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label>Select Module</label>
                  <select className="form-select" name="module_id" value={form.module_id} onChange={handleChange}>
                    <option value="">Select Module</option>
                    {modules.map((mod) => (
                      <option key={mod.id} value={mod.id}>{mod.name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label>Select Topic</label>
                  <select className="form-select" name="topic_id" value={form.topic_id} onChange={handleChange}>
                    <option value="">Select Topic</option>
                    {topics.map((topic) => (
                      <option key={topic.id} value={topic.id}>{topic.name}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Due Date & Task */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label>Due Date</label>
                  <input type="date" name="due_date" className="form-control" value={form.due_date} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                  <label>Available Tasks</label>
                  <Select
                    isMulti
                    name="task_ids"
                    options={tasks.map((task) => ({
                      value: task.id,
                      label: task.task || `Task ${task.id}`,
                    }))}
                    value={tasks.filter((t) => Array.isArray(form.task_ids) && form.task_ids.includes(t.id)).map((t) => ({
                      value: t.id,
                      label: t.task,
                    }))}
                    onChange={(selectedOptions) =>
                      setForm((prev) => ({
                        ...prev,
                        task_ids: selectedOptions.map((option) => option.value),
                      }))
                    }
                  />
                </div>
              </div>

              {/* Session Type */}
              <div className="mb-3">
                <label>Session Type:</label>
                {["individual", "group"].map((type) => (
                  <div className="form-check form-check-inline ms-2" key={type}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="type"
                      value={type}
                      checked={form.type === type}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          type: e.target.value,
                          student_ids: [],
                          group_ids: [],
                        }))
                      }
                    />
                    <label className="form-check-label text-capitalize">{type}</label>
                  </div>
                ))}
              </div>

              {/* Students or Group */}
{form.type === "individual" && (
  <div className="mb-3">
    <label>Select Students</label>
    <Select
      isMulti
      name="student_ids"
      options={students.map((student) => ({
        value: student.id,
        label: `${student.first_name || ""} ${student.last_name || ""}`.trim(), // ✅ safe join
      }))}
      value={students
        .filter((s) => Array.isArray(form.student_ids) && form.student_ids.includes(s.id))
        .map((s) => ({
          value: s.id,
          label: `${s.first_name || ""} ${s.last_name || ""}`.trim(), // ✅ safe join
        }))}
      onChange={(selectedOptions) =>
        setForm((prev) => ({
          ...prev,
          student_ids: selectedOptions.map((option) => option.value),
        }))
      }
    />
  </div>
)}



              {form.type === "group" && (
                <div className="mb-3">
                  <label>Select Group</label>
                  <Select
                    name="group_ids"
                    options={groups.map((group) => ({
                      value: group.id,
                      label: group.name,
                    }))}
                    value={
                      Array.isArray(form.group_ids)
                        ? groups
                            .filter((g) => form.group_ids.includes(g.id))
                            .map((g) => ({ value: g.id, label: g.name }))
                        : []
                    }
                    onChange={(selectedOption) =>
                      setForm((prev) => ({
                        ...prev,
                        group_ids: selectedOption ? [selectedOption.value] : [],
                      }))
                    }
                  />
                </div>
              )}

              {/* Submit */}
              <div className="text-end">
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Submit
                </button>
              </div>

            </div>
          </div>
        </div>
      }
    />
  );
};

export default MentorAssignNewTask;
